import { render, staticRenderFns } from "./HistoricList.vue?vue&type=template&id=6daa82f4"
import script from "./HistoricList.vue?vue&type=script&lang=js"
export * from "./HistoricList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports